<template>
    <split-pane  :min-percent='10' :default-percent='12' split="vertical"  style="background:white; height:100%">
        <template slot="paneL">
            <el-tree :data="accData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"                       
                        :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                        highlight-current
                        :filter-node-method="filterNode"
                        ref="eltree"
                        default-expand-all
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  class="nodeRoot" >
                     
                     <span style="font-size:14px;color:#409efe"><i class="iconfont icon-zhanghuyue" style="color:#409eff;font-size:16px;"></i>{{ node.label}} </span>
                    </span>                  
                    <span v-else > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>  
        <template slot="paneR">
            <div class="ve-list-page">
            <div style="display:flex;padding-top:3px;background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool"  @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px;line-height:30px;">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" style="width:150px;"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" v-model="txtparam" size="small" style="width:320px; height:30px;  ">
                    <el-button slot="append" size="small" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    <div slot="prepend">
                        <el-select v-model="oper"  size="small" style="width:110px;" >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                    </div>
                </el-input>  
                <el-button @click="freshCalc" icon="iconfont icon-xitongguanli" size="mini"  type="primary" style=" height:35px;margin-left:20px;  ">{{ $LANG('1318', '账户余额计算') }}</el-button>
                <el-button @click="showCalc" icon="iconfont icon-tishi" size="mini"  type="info" style=" height:35px;margin-left:20px;  ">{{ $LANG('0224', '显示账户余额') }}</el-button>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            
            </div>
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol"
                    :table-data="tabData"
                    :columnHiddenOption="columnHiddenOption"
                    :border-around="true"
                    :border-x="true"
                    :border-y="true"
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :event-custom-option="eventCustomOption"
                    :max-height="tabHeight"
                    :virtual-scroll-option="virtualScrollOption"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :scroll-width="0"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false}"
                    ref="tabref">
            </ve-table>
            </div>
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
            <div class="ve-list-page__pagination">
                <div style="float: left;padding-left:6px">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
            </div>
            </div>
            <!-- 选择员工 -->
            <el-dialog :visible.sync="empWin" width="1000px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1667', '选择人员') }}</span>
                </div> 
                <emptmpl @child-sure="empOk"></emptmpl>
            </el-dialog>
            <!-- 选择科目 -->
            <el-dialog :visible.sync="subWin" width="1100px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0076', '收支类别') }}</span>
                </div> 

                <div style="height:90vh;overflow-y:auto"><subject @child-sure="subOk"></subject></div>
            </el-dialog>
            <!-- 往来单位  -->
            <el-dialog :visible.sync="corpWin" width="1000px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0029', '往来单位') }}</span>
                </div> 
                <custSup @child-clnt="clntSel" @child-sup="supSel"></custSup>
            </el-dialog>
            <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addModal" :width="tabWidth" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{typeFlag==='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem class="item-width"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-input :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                            <el-checkbox :disabled="saveFlag" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-date-picker :disabled="saveFlag" type="datetime"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" ></el-date-picker>     
                            <el-select :disabled="saveFlag" v-else-if="item.key==='CASHNO'" v-model="formCol[item.key]" style="width:100%" >
                                <span v-for="(item ,index) in cashArr" :key='index'>
                                    <el-option :label="item.ACCNM" :value="item.IDSEQ" ></el-option>
                                </span>
                            </el-select>  
                            <el-select @change="wordChange" :disabled="saveFlag" v-else-if="item.key==='WORD'" v-model="formCol[item.key]" style="width:100%" >
                                <span v-for="(item ,index) in certArr" :key='index'>
                                    <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                                </span>
                            </el-select>  
                            <el-input type="text" v-else-if="item.key==='ORIENT'" disabled v-model="formCol[item.key]">
                                <div slot="append">
                                    <el-tooltip :content="$LANG('2074', '指示余额的方向： 余额大于0为借、小于0方向为贷、等于0为平')" placement="bottom" effect="light">
                                        <el-button icon="iconfont icon-wenhaoxiao" style="width:50px;color:red"></el-button>
                                    </el-tooltip>
                                </div>
                            </el-input>
                            <el-input type="text" v-else-if="item.key==='EMPNM'" disabled v-model="formCol[item.key]">
                                <div slot="append">
                                    <el-button @click="empChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                </div>
                            </el-input>
                            <el-input type="text" v-else-if="item.key==='ORGNM'" disabled v-model="formCol[item.key]">
                                <div slot="append">
                                    <el-button @click="orgChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                </div>
                            </el-input>
                            <el-input type="text" v-else-if="item.key==='ACNM'" readonly  v-model="formCol[item.key]">
                                <div slot="append">
                                    <el-button @click="subChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                                </div>
                            </el-input>
                            <el-input-number :precision="item.dotnum" style="width:100%" v-else-if="item.key=='BAMT'"  :disabled="bFlag||saveFlag" :class="bFlag?'yellow':''"  v-model="formCol[item.key]"></el-input-number>
                            <el-input-number :precision="item.dotnum" style="width:100%"  v-else-if="item.key=='DAMT'"  :disabled="aFlag||saveFlag" :class="aFlag?'yellow':''" v-model="formCol[item.key]"></el-input-number>
                            
                            <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="formCol[item.key]"></el-input>
                            <span slot="label" v-if="item.key==='DAMT'"><span style="color:red">{{item.title}}</span></span>
                            <span slot="label" v-else-if="item.key==='BAMT'"><span style="color:green">{{item.title}}</span></span>
                        </FormItem>
                    </span>
                </Form>   
                <div style="line-height:30px;border:1px solid #ccc;margin-bottom:6px; ">
                    <el-button  class="button-new-tag" icon="iconfont icon-xinzeng" size="mini" type="text" plain @click="showInput">{{ $LANG('0181', '新增标签') }}</el-button>
                    <span v-for="(item ,index) in tagArr" :key="index" > 
                        <el-tag   closable @close="tagClose(item)">{{item}}</el-tag>
                    </span>
                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>  
                </div>
                <div class="dtlbar">
                    <span style="color:white;font-size:14px;margin-right:5px; ">{{ $LANG('1065', '凭证明细表') }}</span>
                    <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:38px;"></i>
                    <el-link :disabled="addBool"  @click="dtlAdd" :underline="false" ><span style="font-size:12px;margin-right:15px;color:white">{{ $LANG('0095', '新增记录') }}</span></el-link>
                    <i class="iconfont icon-huizong" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool"  @click="sumPay" :underline="false" ><span style="font-size:12px;margin-right:15px;color:white">{{ $LANG('1112', '汇总为借方') }}</span></el-link>
                    <i class="iconfont icon-huizong" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool"  @click="sumDebit" :underline="false" ><span style="font-size:12px;margin-right:15px;color:white">{{ $LANG('1113', '汇总为贷方') }}</span></el-link>
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    disabled-hover
                    :cell-style="{padding:'2px'}"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="220" 
                    class="custom-table-border"
                    :row-key="getRowKey2"  
                    ref="dtlref" 
                    highlight-current-row>
                    <span v-for="(item,index ) in dtlArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="165">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="editBool" @click="dtlEdit(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:15px;">{{ $LANG('1639', '编辑') }} </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="delBool" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:11px;margin-right:10px;">{{ $LANG('0131', '删除') }} </span></el-link>
                        </template>
                    </el-table-column>                      
                </el-table> 
                    <div class="dtlbar">
                        <span style="color:white;font-size:14px;margin-right:5px; ">{{ $LANG('1154', '上传凭证附件') }}</span>
                    </div>
                    <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png' ]"
                        :max-size="2048"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <el-image :disabled="saveFlag" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link :underline="false" @click="imgPreview(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; "> 
                    <div style="float:right;display:flex;height:35px;line-height:30px;" >
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                    </span>
                    
                    <el-button :disabled="prevFlag" type="text" icon="iconfont icon-shangyiye"  @click="prevRec" style="margin-right:20px;">{{ $LANG('0519', '上行记录') }}</el-button>
                    <el-button :disabled="nextFlag" type="text" icon="iconfont icon-xiayiye1"  @click="nextRec" style="margin-right:20px; ">{{ $LANG('0525', '下行记录') }}</el-button>
                    <el-button size="small" type="info" icon="iconfont icon-shanchu"  @click="addModal=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button size="small" :disabled="saveFlag?true:false" type="primary" icon="iconfont icon-baocun"  @click="modal_ok('x')" style="margin-right:40px;">{{ $LANG('0200', '保存后退出') }}</el-button>
                    <el-button size="small" :disabled="saveFlag?true:false" type="primary" icon="iconfont icon-baocun"  @click="modal_ok('a')" >{{ $LANG('0199', '保存后新增') }}</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 凭证明细新增 -->
            <el-dialog  :show-close="false" :visible.sync="dtlWin" width="950px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{dtlFlag==='create'?$LANG('0106', '明细新增'):$LANG('0107', '明细编辑')}}</span>
                </div> 
                <Form :model="dtlRow" :label-width="120" ref="dtlForm"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in dtlArr" :key="index" >
                        <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input @change="calcAmt"  v-enter-number  v-else-if="item.key==='QTY'" v-model="dtlRow[item.key]" ></el-input>   
                            <el-input-number @change="calcAmt" :precision="item.dotnum"  v-else-if="item.key==='PRC'" v-model="dtlRow[item.key]" style="width:100%"></el-input-number> 
                            <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select  v-else-if="item.key==='UNIT'" v-model="dtlRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in unitArr " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                            </el-select>
                            <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                    <el-button type="text" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="text" icon="iconfont icon-baocun"  @click="dtl_ok" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                </div> 
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="50px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <el-image src="assets/authorize/loading.gif" fit="fill" style="height:30px;background:#F96161" ></el-image>
            </el-dialog>
            <el-dialog :visible.sync="showViewer" width="800px" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
                </div>
                <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
            </el-dialog>
            <!-- 显示余额 -->
            <el-dialog :visible.sync="disWin" width="570px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1290', '现金账户余额') }}</span>
                </div> 
                <span style="margin-left:5px;font-size:14px; color:red;font-weight:600">{{ $LANG('0758', '最近余额计算时间') }} : {{maxDttm}}</span>
                <div style="display:flex;line-height:40px;border-bottom:2px solid #409EFF">
                    <div style="width:350px; ">{{ $LANG('1291', '现金账户名称') }}</div>
                    <div style="width:200px; ">{{ $LANG('1319', '账户实时余额') }}</div>
                </div>
                <div style="display:flex;line-height:38px;border-bottom:1px solid #ccc" v-for="(item ,index) in cashArr" :key='index'>
                    <div style="width:350px; ">{{item.ACCNM}}</div>
                    <div style="width:200px; ">{{item.CURAMT}}</div>
                </div>
            </el-dialog>
                <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
        </template>       
    </split-pane> 
    
</template>

<script>
  import emptmpl from '../datamgt/hremp_tmpl.vue'
  import custSup from '../datamgt/cust_sup.vue'
  import subject from '../datamgt/inout_tmpl.vue'
  import { getTabColOrData,getBaseData } from '../../api/user'
  import {getDate} from '../../api/Select'
  import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
  export default {
    name: 'inv_daily',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '14401',
            fieldIdseq: '14401',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    components: {
        emptmpl, //人员模板
        custSup,//往来单位
        subject,//科目
        VeColumnConfigDialog,
    },
    data() {
      return {
        tagArr:[],
        prevFlag:false,
        nextFlag:false,
        inputVisible:false,
        inputValue:'',  
        disWin:false,
        promptWin:false,
        dtlWin:false,
        showViewer:false,
        listurl:'',
        uploadData:{}, //上传数据
        unitArr:[],
        prompt:'',
        addModal:false, //modal 
        corpWin:false,
        subWin:false,
        uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
        dtlRow:{},
        formCol:{}, //表格单行记录 model
        accData:[] , //树结构数据
        dtlData:[],
        oper:'like',
        selparam:'',
        txtparam:'',
        Accept: "png,jpg,jpeg", //上传文件格式限制
        dtlFlag:'create',
        empWin:false,
        bFlag:false,
        aFlag:false,
        defaultProps: {  //el-tree 默认字段属性
            children: 'children',
            id:'id',
            icon:'icon',
            parentid:'',
            label: 'label'
        },
        ruleValidate:{}, //校验规则
        loadWin:false,
        typeFlag: 'create',
        nodeLabel:this.$cookies.get('v_corpnm'),
        treeid :'0',
        cashno:'',
        dttm_:'',
        allData:[],
        tabData:[],
        tabArr:[],
        initCol:[],
        vueCol:[],
        columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: { headerCellClass: () => 'table-head-cell-class', bodyCellClass: () => 'table-body-cell-class1' },
            v_headerRow:{},
            queryRequestId:0,
            headerSortKey:'',
            headerSortOrder:'',
        virtualScrollOption: { enable: false },
        eventCustomOption: {
            bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
        },
        dtlArr:[],
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:50,
        goPage:'',
        rowIndex:'-1',
        videoFlag:false,
        videoUploadPercent:0,
        maxDttm:'',
        notNull:[],
        cashArr:[],
        certArr:[],
        delArr:[],
        dtlIndex:'',
        current:1,
        stfgColor:'',
        stfgCss:'',
        imgData:[],
        operArr:[],
        pageList: [   {
            value: 50,
            label: '50'
            }, {
            value: 100,
            label: '100'
        }],
      }
    },
    created () {
        if(this.v_username){
            this.getData() //左边树
            this.getTabField() // 字段集
            this.getAccList(' and cashno=\''+this.cashno+'\' ')
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','14401','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14401','lstseq','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14409','v_ac_account',' and stfg=\'Y\' order by sortby').then(res=>{
            this.cashArr =res.result
        })
        //凭证字
        getBaseData('xuper_auth/getBaseData','PARENTNO','4258','','','v_sys_base','').then(res=>{
            this.certArr =res.result
        })
        //常用单位
        getBaseData('xuper_auth/getBaseData','PARENTNO','14429','','','v_sys_base','').then(res=>{
            this.unitArr =res.result
        })
        this.getMaxDttm()
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 90) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 164) + 'px';
            }, 
            tabWidth(){
                return (window.innerWidth-160) + 'px'
            } ,
        },
    methods: {
        sortHeaderColumn(column, edcss){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) {
                this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            }else{
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            const direction =this.headerSortOrder === 'asc' ? 1 : -1
            const type =String(edcss || '').toLowerCase()
            this.tabData.sort((left, right) => {
                const leftValue =left[key]
                const rightValue =right[key]
                if (leftValue === rightValue) return 0
                if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                if (type === 'date' || type === 'date2' || type === 'time') {
                    return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                }
                return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
            })
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        showCalc(){
            this.disWin =true
        },
        //上一条、下一条
        prevRec(){
            if(this.rowIndex!=='-1'){
                this.rowIndex--
                this.nextFlag=false
                if (this.rowIndex<0){
                    this.rowIndex=0
                    this.prevFlag=true
                }
                this.rowClick(this.allData[this.rowIndex])
                if(this.allData[this.rowIndex].STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
            }
        },
        nextRec(){
            if(this.rowIndex!=='-1'){
                this.rowIndex++
                this.prevFlag=false
                if (this.rowIndex>this.allData.length){
                    this.rowIndex=this.allData.length
                    this.nextFlag=true
                }
                this.rowClick(this.allData[this.rowIndex])
                if(this.allData[this.rowIndex].STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
            }
        },
        //标签的赋予增加
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.tagArr.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        tagClose(tag) {
            this.tagArr.splice(this.tagArr.indexOf(tag), 1);
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
        //图片删除，操作数组
        imgDel(item,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'], p_table:'mat_img'},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        this.imgData.splice(index, 1);   
                        let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                            this.$axios({
                                method: 'post',
                                url: '/xuper_oss/ftpDelete',
                                data: {p_path:'/volume1'+v_path},
                            }).then(res=>{ 
                                console.log(res.result)
                            })
                        }
                    }else{
                        this.prompt=res.message
                        this.promptWin=true
                    }        
                })    
            }).catch(()=>{})
        },
         //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promtWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name + ' '+this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promtWin =true
            this.prompt=file.name + ' '+this.$LANG('1561', '文件太大， 不能超出')+'2M'
        },
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            } else{
                this.promptWin =true
                this.prompt =res.result
            }                
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('0134', '审核'):this.$LANG('0142', '反审核')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_CASH',p_cond:' set stfg=\''+val+'\'' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promtWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //刷新计算余额
        freshCalc(){
            this.$confirm(this.$LANG('1612', '你确定要重新计算账户余额吗?') ,this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin=true
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/calcDayCash',
                    data: {corpid:this.v_corpid,p_user:this.v_username,p_action:'DAY' },
                }).then(res=>{ 
                    if (res.code==='200'){
                        this.loadWin=false
                        this.qryTabData()
                        this.getMaxDttm()
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                        this.loadWin=false
                    }
                })
                // setInterval(()=>{this.loadWin=false},5000)
            }).catch(()=>{})
        },
        getMaxDttm(){
            this.$axios({    //select ${p_key2},max(gpno) gpno,count(1) cnt from ${p_table}
                method: 'post',
                url:'xuper_auth/getRecGroup',
                data: {p_key2:'corpid',p_key:'corpid',p_value:this.v_corpid, p_table:'V_CASH_LOG' },
            }).then(res=>{ 
                if (res.code==='200'){
                    if (res.result.length>0)
                    this.maxDttm=res.result[0].GPNO
                }
            })
        },
        //查询凭证明细记录
        getDtlData(idseq){
            getTabColOrData(this.v_url,'V_fin_cashdtl','idseq',idseq).then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
            })
        },
        //明细确认
        dtl_ok(){
            if (this.dtlFlag==='create'){
                this.dtlData.push(this.dtlRow) //新增
            }else{
                this.dtlData.splice(this.dtlIndex,1,this.dtlRow)  //替换
            }
            this.dtlWin=false
        },
        calcAmt(){
            this.dtlRow['AMT']=this.dtlRow['QTY']*this.dtlRow['PRC']
        },
        dtlAdd(){
            this.dtlRow={}
            this.dtlWin=true
            this.dtlFlag='create'
        },
        //往来单位选择
        clntSel(idseq,clntnm){
            this.formCol['ORGNO']=idseq
            this.formCol['ORGNM']=clntnm
            this.corpWin=false
        },
        supSel(idseq,supnm){
            this.formCol['ORGNO']=idseq
            this.formCol['ORGNM']=supnm
            this.corpWin=false
        },
        //人员选择
        empOk(idseq,empnm){
            this.formCol['EMPNO']=idseq
            this.formCol['EMPNM']=empnm
            this.empWin=false
        },
        empChoose(){
            this.empWin=true
        },
        //科目选择
        subOk(idseq,accnm){
            this.formCol['ACNO']=idseq
            this.formCol['ACNM']=accnm
            this.subWin=false
        },
        subChoose(){
            this.subWin=true
        },
        //往来单位选择
        orgChoose(){
            this.corpWin=true
        },
        wordChange(val){
            if(val==='4259' ||val==='4263'){ //收、现收
                Object.assign(this.formCol,{'DAMT':''})
                this.aFlag=true  
                this.bFlag=false 
            }else if(val==='4260'||val==='4264' ){ //付、现付
                Object.assign(this.formCol,{'BAMT':''})
                this.bFlag=true
                this.aFlag=false   
            }else{
               this.bFlag=false
               this.aFlag=false 
            }
        },
        //汇总为贷方
        sumDebit(){
            if(this.formCol['WORD']==='4259'||this.formCol['WORD']==='4263'){
                this.promptWin=true
                this.prompt=this.$LANG('0826', '当前凭证字为收现收，不能将明细合计设置为贷方金额')
            }else if (this.dtlData.length===0){
                this.promptWin=true
                this.prompt=this.$LANG('1814', '明细记录为空时不能设置')
            }else{
                let v_sum=0
                for(let k=0 ;k<this.dtlData.length;k++){
                    v_sum=v_sum+ Number(this.dtlData[k]['AMT'])
                }    
                this.$confirm(this.$LANG('1586', '是否将明细汇总金额:')+v_sum+this.$LANG('1411', '设置为贷方金额?'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    Object.assign(this.formCol,{DAMT:v_sum,BAMT:''})
                }).catch(()=>{})
            }
        },
        //汇总为借方
        sumPay(){
            if(this.formCol['WORD']==='4260'||this.formCol['WORD']==='4264'){
                this.promptWin=true
                this.prompt=this.$LANG('0825', '当前凭证字为付现付，不能将明细合计设置为借方金额')
            }else if (this.dtlData.length===0){
                this.promptWin=true
                this.prompt=this.$LANG('1814', '明细记录为空时不能设置')
            }else{
                let v_sum=0
                for(let k=0 ;k<this.dtlData.length;k++){
                    v_sum=v_sum+ Number(this.dtlData[k]['AMT'])
                }    
                this.$confirm(this.$LANG('1586', '是否将明细汇总金额:')+v_sum+this.$LANG('1410', '设置为借方金额?'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    Object.assign(this.formCol,{BAMT:v_sum,DAMT:''})
                }).catch(()=>{})
            }
        },
        //查询
        qryTabData(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            if (this.cashno) cond_=` and cashno='${this.cashno}'`+cond_
            if (this.dttm_) cond_=` and dttm like '${this.dttm_}%'`+cond_
            this.current = 1
            this.getAccList( cond_)
        },
        rowShow(){ this.v_headerRow={}; this.qryTabData() },
        getRowKey(row){
            return row.IDSEQ
        },
        getRowKey2(row){
            return row.LSTSEQ
        },
        rowClick(row){
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='N')  { 
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'             
            }else{
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }
            if (row.TAG){
                this.tagArr =row.TAG.split(',')
            }else{
                this.tagArr=[]
            }
            this.formCol =JSON.parse(JSON.stringify(row))
            //凭证明细
            this.getDtlData(row.IDSEQ)
            //产品图片
            this.qryImgData(row.IDSEQ) 
        },
        editRec(row,index){
            if (row.REFDBSEQ){
                this.promptWin=true
                this.prompt=this.$LANG('1938', '当前凭证为账户期初金额自动生成,请在资金账户管理中进行修改')
            }else{
                this.rowIndex =index
                if(row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }
                this.addModal=true 
                this.typeFlag='edit'
                this.wordChange(row.WORD)
                this.delArr=[]
            }
        },
        dtlEdit(row,index ){
            this.dtlRow =JSON.parse(JSON.stringify(row))
            this.dtlWin=true 
            this.dtlFlag='edit'
            this.dtlIndex=index
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt=this.$LANG('1721', '请输入跳至页数')
            }
        },
        //日记账明细
        getAccList(cond){
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by dttm desc',p_table:'V_FIN_CASH'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch((error) => { if (requestId === this.queryRequestId) { this.promptWin=true; this.prompt=error.message || this.$LANG('1641', '查询失败') } })
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.tabData = this.allData.slice(_start,_end);
        },
        //确定 保存
        modal_ok(valStfg){
            //发起保存请求   
            this.$refs['addForm'].validate((valid) => {
                if (valid){   
                    if(!this.formCol['ACNM']){
                        this.promptWin=true
                        this.prompt=this.$LANG('0076', '收支类别')+this.$LANG('2051', '不能为空')
                    }else{
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'IDSEQ', p_value:this.formCol['CASHNO'],p_key2:'corpid', p_value2:this.v_corpid,p_cond:'',p_table:'V_AC_ACCOUNT'},
                        }).then(res=>{
                            let v_dttm=res.result[0].DTTM.substring(0,7)
                            let v_todttm=this.formCol['DTTM'].substring(0,7)
                            if (v_dttm<=v_todttm){ 
                                let obj_=''
                                if (this.tagArr.length>0){
                                    obj_=Object.assign(this.formCol,{CORPID:this.v_corpid,TAG:this.tagArr.join(',')})
                                }else{
                                    obj_=Object.assign(this.formCol,{CORPID:this.v_corpid,TAG:''})
                                }
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/formOneSave',
                                    data: {p_json:JSON.stringify(obj_), p_table:'FIN_CASH',p_frmid:''},
                                }).then(res=>{       
                                    if(res.code ==='200')  { 
                                        let v_idseq= res.idseq
                                        //明细保存
                                        this.$axios({   
                                            method: 'post',
                                            url:'xuper_auth/batDtlSave2',
                                            data: {p_json:JSON.stringify(this.dtlData), p_table:'fin_cashdtl',p_idseq:v_idseq, p_action:'S' },
                                        }).then(res=>{   
                                            if (res.code==='200'){  
                                                if (this.cashno){   
                                                    this.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+ v_todttm +'%\'')
                                                    this.treeid=this.cashno+'-'+v_todttm
                                                }else{
                                                    this.getAccList('') 
                                                }
                                                this.getData() 
                                                if (valStfg==='x'){
                                                    this.addModal =false  
                                                }else{
                                                    this.$message(this.$LANG('1456', '单据已成功保存'))
                                                    this.addRec() //保存后即进入新增状态
                                                }
                                            } else{
                                                this.promptWin=true
                                                this.prompt=res.result
                                            }    
                                        })
                                        //明细删除
                                        if (this.delArr.length>0 ) {
                                            this.$axios({   
                                                method: 'post',
                                                url:'xuper_auth/batDtlSave2',
                                                data: {p_json:JSON.stringify(this.delArr), p_table:'fin_cashdtl',p_idseq:v_idseq, p_action:'D' },
                                            }).then(res=>{   
                                                if (res.code!=='200'){
                                                    this.promptWin=true
                                                    this.prompt=res.result
                                                }    
                                            })
                                        }
                                        //3、图片保存
                                        for(var k=0;k<this.imgData.length;k++){
                                            this.$axios({
                                                method: 'post',
                                                url:'xuper_auth/tableBodySave',
                                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:v_idseq},
                                            })
                                        }   
                                    }else{
                                        this.prompt=res.result
                                        this.promptWin=true
                                    }        
                                }) 
                            }else{
                                this.promptWin=true
                                this.prompt=this.$LANG('1908', '发生日期不能小于资金账户的当前账期:')+v_dttm
                            }
                        }).catch(()=>{
                            this.promptWin=true
                            this.prompt=this.$LANG('1465', '系统错误,请联系管理员')
                        })
                    }
                }
            })
        } ,
        //新增
        addRec(){  
            this.$axios({ //取到最大IDNO +1
                method: 'post',
                url:'xuper_auth/getMaxNum',
                data: {p_key:'idno',p_value:"100",p_key2:'corpid',p_value2:this.v_corpid, p_table:'FIN_CASH'},
            }).then(res=>{      
                if(res.code =='200')  {  
                    this.addModal =true
                    this.typeFlag ='create'
                    this.formCol ={IDSEQ:'',IDNO:res.result,  STFG:'N','DTTM':getDate('full'),CASHNO:this.cashno} 
                    this.delArr=[]   
                    this.dtlData=[]
                    this.imgData =[]
                    this.stfgCss='icon-weishenhe3'
                }else{
                    this.prompt=res.result
                    this.promptWin=true
                }        
            })               
        },
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;          
            this.treeid =data.id
            let index=this.treeid.indexOf('-')
            if(index>-1){
                this.dttm_=this.treeid.substring(index+1)
            }else{
                this.dttm_=data.id
            }
            this.cashno=data.icon
            this.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+this.dttm_+'%\'')
        },
        dtlDel(row,index){
            this.delArr.push(row)
            this.dtlData.splice(index,1)
        },
        //删除记录
        delRec(row){
            if (row.REFDBSEQ){
                this.promptWin=true
                this.prompt=this.$LANG('1939', '当前凭证为账户期初金额自动生成,请在资金账户管理中进行维护')
            }else{
                this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    //发起删除请求
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_CASH'},
                    }).then(res=>{      
                        if(res.code =='200')  {           
                            vm.getData()   
                            vm.getAccList(' and cashno=\''+this.cashno+'\' and dttm like \''+this.treeid+'%\'')  
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }).catch(()=>{})
            }
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_CASH_MENU',p_cond:' and (corpid=\'-1\' or corpid=\''+this.v_corpid+'\') order by sortby'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.accData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }            
            })                            
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14401','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            edcss: item.EDCSS,
                            thide: item.THIDE,
                            holder: item.HOLDER,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                        })
                        if (String(item.THIDE).toUpperCase() !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={item.EDCSS} value={this.v_headerRow[item.key]} operator={this.v_headerRow[`#OPER${item.key}`]} on-input={(value) => this.$set(this.v_headerRow, item.key, value)} on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)} on-query={this.qryTabData} sortable={item.key !== 'RN' && item.EDCSS !== 'checkbox'} sortOrder={vm.headerSortKey === item.key ? vm.headerSortOrder : ''} on-title-click={() => vm.sortHeaderColumn({ key: item.key }, item.EDCSS)} />,
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({ field:'index', key:'rownum', title:vm.$LANG('0310', '序号'), width:55, align:'center', fixed:'left', disableResizing:true, renderBodyCell:({rowIndex}) => rowIndex + 1, renderHeaderCell:({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div> })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 220,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                {row.STFG !== 'Y' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.editBool} on-click={() => vm.editRec(row, rowIndex)} underline={false}><span style="font-size:11px;margin-right:15px;">{vm.$LANG('1639', '编辑')} </span></el-link>
                                </span> : null}
                                <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.delBool} on-click={() => vm.delRec(row)} underline={false}><span style="font-size:11px;margin-right:10px;">{vm.$LANG('0131', '删除')} </span></el-link>
                                {row.STFG !== 'Y' ? <span>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.recSet(row, 'Y')} underline={false}><span style="font-size:11px;margin-right:10px;">{vm.$LANG('0134', '审核')} </span></el-link>
                                </span> : <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.recSet(row, 'N')} underline={false}><span style="font-size:11px;margin-right:10px;">{vm.$LANG('0142', '反审核')} </span></el-link>
                                </span>}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14401','lstseq','2','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号ß
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped lang="less">
.input-new-tag {
    width: 120px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .button-new-tag {
    margin-right: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
 .siderCls{
     background:#fff;
     margin: 3px auto;
     width: 260px;
     min-width: 260px;
     max-width:260px;
     border-right: 2px solid #C0C4CC;
}
    .item-width  {
        width: 48%;
        color:red !important;
    } 
.headbar{
    padding-left:5px; 
    line-height:40px;
    background:#fff;
    overflow: auto;
    padding-top:2px;
    display:flex;
    border-left:2px solid #409eff;
}
.dtlbar{
    padding-left:5px; 
    line-height:35px;
    background:#409eff;
    color: white;
    padding-top:4px;
    display:flex;
    border-left:2px solid #409eff;
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
    .top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    } 
     .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .yellow .el-input__inner {
        background-color: #f5d9b1;    //橙色
    }
    .el-tag  {
        margin-left: 10px;
    }
</style>
